var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 3.56008C12.39 2.53008 11.59 1.57008 10.69 0.710081C10.34 0.370081 9.75 0.690081 9.85 1.17008C10.04 2.11008 10.24 3.35008 10.24 4.46008C10.24 6.52008 8.89 8.19008 6.83 8.19008C5.29 8.19008 4.03 7.26008 3.48 5.93008C3.38 5.73008 3.34 5.61008 3.28 5.39008C3.17 4.97008 2.62 4.84008 2.38 5.21008C2.2 5.48008 2.03 5.75008 1.87 6.04008C0.68 8.08008 0 10.4601 0 13.0001C0 17.4201 3.58 21.0001 8 21.0001C12.42 21.0001 16 17.4201 16 13.0001C16 9.51008 14.92 6.27008 13.09 3.56008ZM7.71 18.0001C5.93 18.0001 4.49 16.6001 4.49 14.8601C4.49 13.2401 5.54 12.1001 7.3 11.7401C8.77 11.4401 10.28 10.8101 11.33 9.82008C11.61 9.56008 12.07 9.68008 12.15 10.0501C12.38 11.0701 12.5 12.1301 12.5 13.2001C12.51 15.8501 10.36 18.0001 7.71 18.0001Z",
    fill: "#F18C46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.dde1b5c4.svg";
export { ForwardRef as ReactComponent };